import POST_COMPONENT_TYPE from '../postComponentType';
import AntiMullerionHormoneHero from '../../../assets/images/anti-mullerian-hormone-hero-section.png';
import { IconType } from '../../../components/BannerWithList';

const antiMullerianHormone = {
  key: 'anti-mullerian-hormone',
  sectionList: [
    {
      type: POST_COMPONENT_TYPE.bannerWithTextAndDescription,
      title: 'learnMoreContent.anti-mullerian-hormone.infoBanner.title',
    },
    {
      type: POST_COMPONENT_TYPE.title,
      text: 'learnMoreContent.anti-mullerian-hormone.name',
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextBox,
      image: AntiMullerionHormoneHero,
      text: 'learnMoreContent.anti-mullerian-hormone.banner.text',
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.anti-mullerian-hormone.relevance.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.anti-mullerian-hormone.relevance.listItem1',
              type: 'text',
            },
            {
              text: 'learnMoreContent.anti-mullerian-hormone.relevance.listItem2',
              type: 'text',
            },
            {
              text: 'learnMoreContent.anti-mullerian-hormone.relevance.listItem3',
              type: 'text',
            },
            {
              text: 'learnMoreContent.anti-mullerian-hormone.relevance.listItem4',
              type: 'text',
            },
            {
              text: 'learnMoreContent.anti-mullerian-hormone.relevance.listItem5',
              type: 'text',
            },
          ],
        },
      ],
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextAndDescription,
      title: 'learnMoreContent.anti-mullerian-hormone.important.title',
      description: {
        text: 'learnMoreContent.anti-mullerian-hormone.important.description',
        type: 'text',
      },
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.anti-mullerian-hormone.factors.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.anti-mullerian-hormone.factors.listItem1',
              type: 'text',
            },
            {
              text: 'learnMoreContent.anti-mullerian-hormone.factors.listItem2',
              type: 'text',
            },
            {
              text: 'learnMoreContent.anti-mullerian-hormone.factors.listItem3',
              type: 'text',
            },
            {
              text: 'learnMoreContent.anti-mullerian-hormone.factors.listItem4',
              type: 'text',
            },
          ],
        },
      ],
    },
  ],
};

export default antiMullerianHormone;
